import React, { useState } from 'react'
import {
    ListViewProvider,
} from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import { QueryRequestProvider } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import { useAuth } from '../../../../auth'
import ProcessMaterial from './process/ProcessMaterial'

const OperationWrapper = () => {
    const { auth }: any = useAuth()


    return (
        <QueryRequestProvider
            initialValue={{
                initialApi: `productions/filtered?franchiseId=${auth?.data?.franchiseId}&filterType=TEST&status=QC_COMPLETE`,
            }}
        >
            <QueryResponseProvider>
                <ListViewProvider>
                    <ProcessMaterial />
                </ListViewProvider>
            </QueryResponseProvider>
        </QueryRequestProvider>
    )
}

export { OperationWrapper }
